import { render, staticRenderFns } from "./GeneralIndicatorsAgentsSection.vue?vue&type=template&id=f798b894&scoped=true"
import script from "./GeneralIndicatorsAgentsSection.vue?vue&type=script&lang=js"
export * from "./GeneralIndicatorsAgentsSection.vue?vue&type=script&lang=js"
import style0 from "./GeneralIndicatorsAgentsSection.vue?vue&type=style&index=0&id=f798b894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f798b894",
  null
  
)

export default component.exports